import PageHeader from "components/PageHeader";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import ProjectItem from "components/OurProjects/components/ProjectItem";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchGalleryItemById,
  selectGalleryIsLoading,
  selectProjectItemById,
  setProjectItemById,
} from "features/gallery/gallerySlice";
import Preloader from "components/Preloader/Preloader";
import { Helmet } from "react-helmet";

interface GalleryItemProps {}

const GalleryItem: React.FC<GalleryItemProps> = ({}) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const isLoading = useSelector(selectGalleryIsLoading);
  const projectById = useSelector(selectProjectItemById);

  useEffect(() => {
    dispatch(fetchGalleryItemById(id));

    return () => {
      dispatch(setProjectItemById(null));
    };
  }, []);

  if (isLoading) {
    return (
      <PreloaderContainer>
        <Preloader />
      </PreloaderContainer>
    );
  }

  const mainImage = projectById?.images.find(
    (item) => item.is_main_image === true
  );

  return (
    <>
      <Helmet>
        {projectById?.titleMeta && <title>{projectById?.titleMeta}</title>}
        {projectById?.descriptionMeta && (
          <meta name="description" content={projectById.descriptionMeta} />
        )}
        {projectById?.tagsMeta && (
          <meta property="keywords" content={projectById?.tagsMeta} />
        )}
      </Helmet>
      {projectById && (
        <>
          {mainImage && (
            <PageHeader title={projectById.title} img={mainImage} />
          )}
          <GalleryItemContainer>
            {projectById.description && (
              <div>
                <h3>За проекта</h3>
                <span className="text-body">{projectById.description}</span>
              </div>
            )}
            <SectionTitle>Използвани климатици</SectionTitle>
            <ProductsContainer>
              {projectById.items.map((item, idx) => (
                <ProjectItem key={idx} item={item} />
              ))}
            </ProductsContainer>
            <SectionTitle>Снимки</SectionTitle>
            <GalleryImages>
              {projectById.images.map((item, idx) => (
                <ImageContainer>
                  <Image
                    key={idx}
                    className="custom-image"
                    src={`data:${item.contentType};base64,${item.image}`}
                    alt={item.alt}
                  />
                </ImageContainer>
              ))}
            </GalleryImages>
          </GalleryItemContainer>
        </>
      )}
    </>
  );
};

const PreloaderContainer = styled.div`
  margin-top: 10%;
`;
const GalleryItemContainer = styled.div`
  margin: 0 10px;

  @media only screen and (${device.laptop}) {
    margin: 0 20px;
  }
`;

const SectionTitle = styled.h3`
  margin-top: 12px;

  @media only screen and (${device.laptop}) {
    margin-top: 20px;
  }
`;

const ProductsContainer = styled.div`
  margin-bottom: 12px;

  @media only screen and (${device.laptop}) {
    margin-bottom: 20px;
  }
`;

const GalleryImages = styled.div`
  display: grid;
  grid-template-columns: repeat(1fr);
  padding: 10px 0;
  grid-gap: 10px;

  @media only screen and (${device.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (${device.laptop}) {
    grid-template-columns: repeat(3, 1fr);
    padding: 20px;
  }

  @media only screen and (${device.desktop}) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const ImageContainer = styled.div`
  position: relative;
  padding-top: 75%;
`;

const Image = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
`;

export default GalleryItem;
